import React from 'react';

import { Link } from 'react-router-dom';

import EnvelopeUrl from '@pkg/assets/images/Envelope.png';
import { DepButton } from '@pkg/components/deprecated';

import { Typography } from '../DesignSystem';

import { Container, EmojiImage, FormGroup, FormRow, PrimaryCopySection, Section } from './styles';

export function EmailActivation() {
    // const { setCurrentStep } = useContext(Web3AuthContext);
    const emailAddress = 'mycoolemail@test.com';

    return (
        <Container>
            <Section>
                <EmojiImage src={EnvelopeUrl} />
            </Section>
            <PrimaryCopySection>
                <Typography type="headline" size={40}>
                    Check your inbox for an email from us!
                </Typography>
                <Typography type="paragraph" size={18} faded={true}>
                    We sent an email to <em>{emailAddress}</em>. Confirm your email to finish creating your account.
                </Typography>
            </PrimaryCopySection>
            <Section>
                <FormGroup>
                    <FormRow>
                        <DepButton variant="glow">Resend email</DepButton>
                    </FormRow>
                    <FormRow>
                        <Link to="#update-email">Update your email address</Link>
                    </FormRow>
                </FormGroup>
            </Section>
        </Container>
    );
}
